import { Record } from 'immutable'

interface Props {
  id: number
  client_id: number
  code: string
  zip_code: string
  prefecture_id: number
  address1: string
  address2: string
  address3: string
  name: string
  custom_name: string
  kana: string
  kana_eng: string
  category1: string
  category2: string
  category3: string
  invite_hidden: boolean
  guest_hidden: boolean
  coming_hidden: boolean
  select_option1: string
  select_option2: string
  select_option3: string
  select_option4: string
  select_option5: string
  shop_page_url: string
}

const ShopRecord = Record<Props>({
  id: 0,
  client_id: 0,
  code: '',
  zip_code: '',
  prefecture_id: 0,
  address1: '',
  address2: '',
  address3: '',
  name: '',
  custom_name: '',
  kana: '',
  kana_eng: '',
  category1: '',
  category2: '',
  category3: '',
  invite_hidden: false,
  guest_hidden: false,
  coming_hidden: false,
  select_option1: '',
  select_option2: '',
  select_option3: '',
  select_option4: '',
  select_option5: '',
  shop_page_url: '',
})

export default class Shop extends ShopRecord { }
